import './footer.css'
import { AiFillFacebook } from "react-icons/ai";
import { AiFillGoogleCircle } from "react-icons/ai";
import { AiFillInstagram } from "react-icons/ai";
// import { Link } from 


function Footer() {

    return (
        <div className='footer'>
            <div className='footer-logo'>
                <h1 id='footer-logo1'>SOZO</h1>
                <h1 id='footer-logo2'>Sports Physical Therapy, LLC</h1>
                <h5 id='footer-logo3'>Providing mobile physical therapy service in Tulsa and surrounding areas in Oklahoma</h5>
                <br />
                
            </div>
            <div className='footer-contact'>
                {/* <h5 id='footer-contact'>Hours: M - F 8AM to 6 PM</h5>
                <h5 id='footer-contact'>Saturday: By Appointment Only</h5> */}
                <h5 id='footer-contact'>M-Sat: By appointment only (flexibility around your schedule)</h5>
                <h5 id='footer-contact'>Phone: 314-791-5652</h5>
                <h5 id='footer-contact'>Email: Tricia@sozosportspt.com</h5>
            </div>
            <div className='footer-icons'>
                <div><a id='footer-icons' href='https://www.facebook.com/sozosportspt' target='_blank'> <AiFillFacebook id='footer-icons'/> </a></div>
                <div><a id='footer-icons' href='https://www.google.com/maps/place/Sozo+Sports+Physical+Therapy/@36.1462025,-96.0242659,11z/data=!4m6!3m5!1s0x2c98e8696dbdac67:0xae48438c8f92d96f!8m2!3d36.1523015!4d-95.8780104!16s%2Fg%2F11s5fvyc_6?entry=ttu' target='_blank'> <AiFillGoogleCircle id='footer-icons'/> </a></div>
                <div><a id='footer-icons' href='https://www.instagram.com/invites/contact/?i=hu01ff4idgua&utm_content=mji4sv9' target='_blank'><AiFillInstagram/></a></div>
            </div>
            
        </div>
    )
}

export default Footer;